<template>
  <div class="content-box">
    <div class="search-form cml-tab-button-group">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="包材" name="package">
          <PackageSample ref="package" />
        </el-tab-pane>
        <el-tab-pane label="原料" name="material">
          <MaterialSample ref="material" />
        </el-tab-pane>
        <el-tab-pane label="膜布" name="membrane">
          <MembraneSample ref="membrane" />
        </el-tab-pane>
        <el-tab-pane label="ODM产品" name="ODM">
          <ODMSample ref="ODM" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import PackageSample from './PackageSample';
import MaterialSample from './MaterialSample';
import MembraneSample from './MembraneSample';
import ODMSample from './ODMSample';
export default {
  name: 'sample-application',
  components: {
    PackageSample,
    MaterialSample,
    MembraneSample,
    ODMSample,
  },
  data() {
    return {
      activeName: 'package',
    };
  },
  watch: {
    activeName(val) {
      this.$refs[val].getList();
    },
  },
  mounted() {
    this.$store.dispatch('addSampleToCart/getShoppingCartList');
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.content-box {
  max-width: 1170px;
  padding: 0 20px;
  margin: 0 auto;
}
/deep/ .search-Type {
  margin-bottom: 5px;
}
/deep/ .search-form {
  .el-tabs__nav {
    overflow: hidden;
  }
}
</style>
